import { render, staticRenderFns } from "./PathSidebar.vue?vue&type=template&id=20ce37c2&scoped=true"
import script from "./PathSidebar.vue?vue&type=script&lang=ts"
export * from "./PathSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce37c2",
  null
  
)

export default component.exports